import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacilities = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "128.000000pt",
	height: "96.000000pt",
	viewBox: "0 0 128.000000 96.000000",
	preserveAspectRatio: "xMidYMid meet",
	id: "svg316",
	"sodipodi:docname": "Facilities.svg",
	"inkscape:version": "1.2.2 (b0a8486, 2022-12-01)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs320" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview318",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:document-units": "pt",
			showgrid: "false",
			"inkscape:zoom": 1.84375,
			"inkscape:cx": -1.0847458,
			"inkscape:cy": 64,
			"inkscape:window-width": 1309,
			"inkscape:window-height": 456,
			"inkscape:window-x": 2670,
			"inkscape:window-y": 611,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "g314"
		}),
		/* @__PURE__ */ _jsx("metadata", {
			id: "metadata310",
			children: "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(0.05,0,0,-0.05,-2.8474576,95.18644)",
			fill: "#000000",
			stroke: "none",
			id: "g314",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m 1420,1660 c 0,-27 -13,-40 -40,-40 -23,0 -40,-13 -40,-32 0,-17 18,-36 40,-42 102,-27 48,-95 -220,-276 L 900,1094 v -94 -95 L 760,843 c -77,-35 -149,-63 -160,-63 -11,0 -20,-9 -21,-20 -1,-26 -1,-454 0,-481 1,-13 111,-18 316,-15 l 315,6 10,148 c 18,264 140,255 140,-10 V 260 h 398 c 473,0 422,-54 422,441 0,370 -1,379 -45,407 -25,16 -175,96 -335,179 -301,156 -374,229 -261,259 52,13 53,55 3,68 -21,5 -43,27 -48,48 -14,51 -74,49 -74,-2 z m 221,-400 c 104,-54 245,-129 314,-165 l 125,-65 V 695 360 h -210 -210 v 227 227 l -125,87 c -69,47 -150,107 -180,131 l -55,46 -150,-69 -150,-68 1,55 c 1,46 33,76 225,207 123,85 224,154 225,155 0,1 86,-43 190,-98 z m -431,-405 -8,-45 32,45 c 19,28 51,45 83,45 29,0 44,-7 33,-15 -21,-16 -29,-185 -8,-185 6,0 11,-14 11,-30 0,-27 -5,-27 -46,0 -26,17 -47,24 -47,15 0,-8 -8,-3 -18,12 -13,21 -19,20 -29,-5 -7,-18 -1,-33 13,-33 13,-1 3,-10 -23,-20 -31,-13 -43,-30 -35,-50 6,-18 3,-26 -8,-19 -11,7 -20,26 -20,42 0,21 -14,25 -51,16 -51,-13 -51,-12 -45,108 5,104 10,118 39,103 22,-12 46,-6 78,22 57,49 58,49 49,-6 z M 912,768 C 905,751 900,652 900,548 V 360 H 780 660 v 167 166 l 105,51 c 126,62 164,68 147,24 z m 563,12 c 3,-3 13,-6 23,-7 34,-5 45,-29 20,-44 -17,-11 -19,-7 -8,13 9,16 9,21 -1,12 -9,-8 -20,-40 -22,-70 -5,-46 -3,-48 12,-14 15,34 17,32 18,-20 1,-33 5,-93 9,-134 4,-41 0,-70 -9,-64 -10,6 -13,18 -7,27 5,9 -4,22 -20,28 -17,7 -30,28 -31,47 0,44 -48,110 -66,92 -7,-7 -13,-3 -13,9 0,13 9,28 20,35 11,7 20,23 20,36 -1,16 -6,15 -18,-3 -12,-20 -19,-14 -26,21 -8,42 67,69 99,36 z M 1113,607 c -7,-8 0,-29 17,-47 27,-30 27,-33 -5,-33 -53,-1 -91,59 -49,77 46,18 53,18 37,3 z",
					id: "path312"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1057.6271,772.88134 c 49.3799,16.45996 122.8815,42.92377 178.9831,56.94916 2.6309,0.65775 10.8474,0 8.1356,0 -26.8862,0 -44.8011,1.33755 -73.2204,-8.13559 -31.7732,-10.59107 -79.8793,-48.81357 -113.8983,-48.81357 -134.33016,0 82.3927,7.09888 56.9492,32.54238 -3.8352,3.83515 -10.8475,0 -16.2712,0 -36.2402,0 -70.4959,8.13559 -105.76273,8.13559 -2.71187,0 5.42373,0 8.13563,0 35.2542,0 70.5084,0 105.7627,0 51.5254,0 103.0508,0 154.5762,0",
					id: "path1116"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1155.2542,837.96609 c -380.01787,-22.354 -50.7697,20.37006 -162.71183,-24.40678 -7.5537,-3.02148 -18.65405,5.75273 -24.40677,0 -1.91759,-1.91758 1.91757,-6.21801 0,-8.13559 -1.91759,-1.91757 -6.21803,1.91758 -8.1356,0 -1.91758,-1.91757 0,-5.42373 0,-8.1356 0,-27.3202 23.03823,-16.27119 48.8136,-16.27119",
					id: "path1118"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1057.6271,789.15252 c 227.7469,25.30522 145.9901,24.40679 244.0678,24.40679",
					id: "path1120"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1261.0169,854.23727 24.4068,-16.27118",
					id: "path1122"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1301.6949,789.15252 c 33.0747,-9.81731 74.4962,-16.90912 105.7627,-32.54236 6.7148,-3.35739 12.127,-40.52518 16.2712,-48.81357 9.3551,-18.71025 31.2345,-29.92657 40.678,-48.81356 2.4653,-4.93066 4.7264,-20.99761 8.1356,-24.40676 8.6878,-8.68789 22.9386,-14.80305 32.5423,-24.40679",
					id: "path1124"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1448.1356,707.79659 c 34.0466,-51.06996 12.9868,-48.81356 40.678,-48.81356",
					id: "path1126"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1008.8136,903.05084 c 105.7627,-27.11865 211.4977,-54.34562 317.2881,-81.35593 21.6675,-5.53214 43.2546,-11.42006 65.0847,-16.27119 2.6473,-0.5883 6.2181,1.91758 8.1356,0 3.8352,-3.83516 -3.8351,-12.43604 0,-16.27119 1.9176,-1.91757 6.2181,1.91758 8.1356,0 7.2523,-7.25222 3.8155,-23.90217 8.1356,-32.54237 1.7151,-3.43027 6.9228,-4.49725 8.1356,-8.13559 4.2732,-12.8195 -1.9475,-30.59483 8.1356,-40.67798 1.9176,-1.91757 6.218,1.91759 8.1356,0 4.2878,-4.28782 3.8478,-11.98335 8.1356,-16.27117 6.0604,-6.06044 27.9455,-11.67431 32.5424,-16.27119 19.9852,-2.9009 3.3786,-17.27139 8.1356,-24.40679 6.382,-9.57312 19.2613,-14.11597 24.4067,-24.40677 5.1558,-10.31151 0,-37.03174 0,-48.81357",
					id: "path1128"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					d: "m 1252.8814,683.38982 c 0,-3.34995 2.1535,-22.25325 0,-24.40679 -4.2879,-4.28782 -11.9834,-3.84775 -16.2712,-8.13559 -4.2879,-4.28783 -3.8478,-11.98335 -8.1356,-16.27118 -2.7119,-2.71186 -21.6949,-5.42373 -24.4068,-8.13559 -22.8182,-22.81821 34.1874,9.12259 -8.1356,-16.27119 -38.9815,-23.3889 -81.9705,-52.7277 -130.1695,-40.67798 -8.4701,2.11752 -13.6844,35.12918 -8.1356,40.67798 1.9176,1.91757 6.218,-1.91758 8.1356,0 0.8775,0.87746 -15.6617,81.56923 -16.2712,89.49153 -8.8381,114.89531 -12.6977,44.85895 0,146.44067 -45.2601,-53.89632 -64.82555,-106.28105 -32.5423,-170.84746 18.6167,-37.23341 -3.372,34.52271 16.2711,-24.40678 6.3507,-19.05204 11.1915,-44.76597 16.2712,-65.08474 2.8719,-11.4875 -5.2312,-30.21548 0,-40.67797 4.2304,-8.46078 57.5698,-12.51369 65.0848,-16.27118 10.8964,-5.44823 11.2729,-19.40851 16.2712,-24.40678 1.1805,-1.18056 30.4159,-8.1356 32.5423,-8.1356",
					id: "path1130"
				}),
				/* @__PURE__ */ _jsx("rect", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					id: "rect1184",
					width: 512.54236,
					height: 268.47458,
					x: 1016.9492,
					y: -894.91528,
					transform: "scale(1,-1)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					id: "rect1186",
					width: 178.98305,
					height: 154.57628,
					x: 1000.6779,
					y: -667.11859,
					transform: "scale(1,-1)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					id: "rect1188",
					width: 219.66101,
					height: 252.20338,
					x: 1366.7797,
					y: -634.57629,
					transform: "scale(1,-1)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					style: {
						fill: "#000000",
						strokeWidth: 15
					},
					id: "rect1190",
					width: 130.16949,
					height: 73.220337,
					x: 1236.6101,
					y: -935.5932,
					transform: "scale(1,-1)"
				})
			]
		})
	]
});
export default SvgFacilities;
